import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrPatientIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M8 7.68831C10.0779 7.68831 11.8442 5.92208 11.8442 3.84416C11.8442 1.76623 10.0779 0 8 0C5.92208 0 4.15584 1.76623 4.15584 3.84416C4.15584 5.92208 5.92208 7.68831 8 7.68831ZM8 1.45455C9.35065 1.45455 10.3896 2.49351 10.3896 3.84416C10.3896 5.19481 9.35065 6.23377 8 6.23377C6.64935 6.23377 5.61039 5.19481 5.61039 3.84416C5.61039 2.49351 6.64935 1.45455 8 1.45455ZM16 15.2727C16 15.6883 15.6883 16 15.2727 16C14.8571 16 14.5455 15.6883 14.5455 15.2727C14.5455 12.3636 11.7403 9.76623 8 9.76623C4.25974 9.76623 1.45455 12.3636 1.45455 15.2727C1.45455 15.6883 1.14286 16 0.727273 16C0.311688 16 0 15.6883 0 15.2727C0 11.3247 3.74026 8.31169 8 8.31169C12.2597 8.31169 16 11.3247 16 15.2727Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrPatientIconComponent;
